// src/api/service/services.service.ts

import { apiClient } from "../../config";
import { env } from "../../../config/env";

import {
    GetServicesResponse,
    GetServiceResponse,
    UpdateServicePayload,
    CreateServicePayload,
    ServiceImageResponse,
    ServiceCrudResponse,
} from "../../interface/services.interface";

/**
 * ============================================
 * 🧠 SERVICES SERVICE
 * ============================================
 */

class ServicesService {
    /**
     * 📦 GET ALL SERVICES (ADMIN)
     */
    async getServices(): Promise<GetServicesResponse> {
        const { data } = await apiClient.get<GetServicesResponse>(
            env.ADMIN_SERVICES_URL
        );
        return data;
    }

    /**
     * 📄 GET ONE SERVICE
     */
    async getService(id: string): Promise<GetServiceResponse> {
        const { data } = await apiClient.get<GetServiceResponse>(
            `${env.ADMIN_SERVICES_URL}/${id}`
        );
        return data;
    }

    /**
     * ➕ CREATE SERVICE
     */
    async createService(
        payload: CreateServicePayload
    ): Promise<ServiceCrudResponse> {
        const { data } = await apiClient.post<ServiceCrudResponse>(
            env.ADMIN_SERVICES_URL,
            payload
        );
        return data;
    }

    // src/api/service/services.service.ts
    async createServiceWithImage(formData: FormData): Promise<ServiceCrudResponse> {
        const { data } = await apiClient.post<ServiceCrudResponse>(
            env.ADMIN_SERVICES_URL,
            formData,
            {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            }
        );
        return data;
    }

    /**
     * ✏️ UPDATE SERVICE
     */
    async updateService(
        id: string,
        payload: UpdateServicePayload
    ): Promise<ServiceCrudResponse> {
        const { data } = await apiClient.put<ServiceCrudResponse>(
            `${env.ADMIN_SERVICES_URL}/${id}`,
            payload
        );
        return data;
    }

    /**
     * 🖼️ UPLOAD SERVICE IMAGE
     */
    async updateServiceImage(
        id: string,
        file: File
    ): Promise<ServiceImageResponse> {
        const formData = new FormData();
        formData.append("image", file);

        const { data } = await apiClient.post<ServiceImageResponse>(
            `${env.ADMIN_SERVICES_URL}/${id}/image`,
            formData,
            {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            }
        );

        return data;
    }

    /**
     * 🗑️ DELETE SERVICE
     */
    async deleteService(id: string): Promise<ServiceCrudResponse> {
        const { data } = await apiClient.delete<ServiceCrudResponse>(
            `${env.ADMIN_SERVICES_URL}/${id}`
        );
        return data;
    }
}

/**
 * SINGLETON EXPORT
 */
export const servicesService = new ServicesService();